import { useCallback, useState } from "react"

const useFocusWithin = ({
  onFocusWithin,
  onBlurWithin,
}: { onFocusWithin?: () => void; onBlurWithin?: () => void } = {}) => {
  const [isFocusWithin, setIsFocusWithin] = useState(false)

  const onFocus = useCallback(() => {
    if (!isFocusWithin) {
      setIsFocusWithin(true)
      onFocusWithin?.()
    }
  }, [isFocusWithin, onFocusWithin])

  const onBlur = useCallback(
    (e: React.FocusEvent) => {
      // イベントリスナーを設定した要素内に、次のfocus先の要素が含まれていない場合
      if (isFocusWithin && !e.currentTarget.contains(e.relatedTarget as HTMLElement)) {
        setIsFocusWithin(false)
        onBlurWithin?.()
      }
    },
    [isFocusWithin, onBlurWithin]
  )

  return {
    isFocusWithin,
    focusWithinProps: {
      onFocus,
      onBlur,
    },
  }
}

export default useFocusWithin
